
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/draggable.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"draggable","toc":"menu","filename":"docs/demo/draggable.md","lastUpdated":1674027995000,"nav":{"title":"Demo","path":"/demo"}};